import { jsxs as m, jsx as l } from "react/jsx-runtime";
import { c as d } from "./clsx-OuTLNxxd.js";
import { MOBILE_BREAKPOINT as e } from "./config/mediaQueries.js";
const a = {
  "is-extra-small": "_is-extra-small_17143_29",
  "is-small": "_is-small_17143_32",
  "is-medium": "_is-medium_17143_35",
  "is-large": "_is-large_17143_38",
  "is-extra-large": "_is-extra-large_17143_41",
  "is-auto": "_is-auto_17143_44",
  "is-full-width": "_is-full-width_17143_47",
  "no-border": "_no-border_17143_50",
  "has-sm-border": "_has-sm-border_17143_53",
  "has-full-border": "_has-full-border_17143_56",
  "dialog-overlay-show": "_dialog-overlay-show_17143_1",
  "dialog-content-show": "_dialog-content-show_17143_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_17143_1"
};
function x({
  srcMobile: i,
  width: o = "auto",
  borderRadius: r = "none",
  className: _ = "",
  ...s
}) {
  const t = d(a.img, _, a[n[o]], a[u[r]]);
  return /* @__PURE__ */ m("picture", { children: [
    i && /* @__PURE__ */ l("source", { media: `(max-width: ${e}px)`, srcSet: i }),
    /* @__PURE__ */ l("source", { media: `(min-width: ${e + 1}px)` }),
    /* @__PURE__ */ l("img", { ...s, className: t, alt: s.alt, style: { width: `${s.widthInPx}px` } })
  ] });
}
const n = {
  xsmall: "is-extra-small",
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  xlarge: "is-extra-large",
  auto: "is-auto",
  full: "is-full-width"
}, u = {
  none: "no-border",
  small: "has-sm-border",
  full: "has-full-border"
};
export {
  u as B,
  x as I,
  n as a
};
